<div class="browser-warning">
  <acc-card>
    <acc-card-header>{{ 'browser.check.title'|translate }}</acc-card-header>
    <acc-card-body>
      <p [innerHTML]="'browser.check.text'|translate"></p>
      <ul>
        <li>
          <a href="https://www.google.com/chrome/" accExternalLink>
            {{ 'browser.check.chrome'|translate:{version: chromeVersion} }}
          </a>
        </li>
        <li>
          <a href="https://www.mozilla.org/firefox/" accExternalLink>
            {{ 'browser.check.firefox'|translate:{version: firefoxVersion} }}
          </a>
        </li>
        <li>
          <a href="https://www.microsoft.com/edge/" accExternalLink>
            {{ 'browser.check.edge'|translate:{version: edgeVersion} }}
          </a>
        </li>
        <li>
          <a href="https://brave.com/" accExternalLink>
            {{ 'browser.check.brave'|translate:{version: chromeVersion} }}
          </a>
        </li>
      </ul>
      <acc-button class="mt-3" (accClick)="ignoreBrowserCheck()" status="outline-warning">
        <div class="d-flex gap-2">
          <div>{{ 'browser.check.ignore'|translate }}</div>
          <acc-icon name="warn" styling="warning" [ngbTooltip]="'browser.check.ignore.warn'|translate"/>
        </div>
      </acc-button>
    </acc-card-body>
  </acc-card>
</div>
